export default "__VITE_ASSET__CbOrcLu7__"